//Separate characters in mask to array of 10 with 2 characters at each index
export const mapMask = (mask: string) => {
    const separated = mask.split("");

    return separated.reduce((result: string[], val, index) => {
        if (index % 2 === 0 && index !== separated.length) {
            result.push(val + (separated[index + 1] || ""));
        }
        return result;
    }, []);
};

//Join the string of characters for mask
export const formatMask = (mask: string[]) => {
    return mask ? mask.join("").trim() : "";
};
